<ng-container [ngSwitch]="loaderType" *ngIf="isLoading">
  <div class="shimmer-loader" *ngSwitchCase="LOADER_TYPES.SHIMMER"></div>
  <ng-container *ngSwitchCase="LOADER_TYPES.SPINNER">
    <div class="spinner-overlay">
      <div class="spinner" [ngStyle]="{
          height: loaderConfig.height + 'px',
          width: loaderConfig.height + 'px',
          border: loaderConfig.thickness + 'px solid rgba(0, 0, 0, 0.1)',
          borderLeftColor: loaderConfig.isDarkBg ?  '#f4cc80' : '#222325',
        }"></div>
    </div>
  </ng-container>
  <div *ngSwitchDefault>
    <img src="assets/images/image-loader.gif" class="image-loader" alt="fetching-image" srcset="" />
  </div>
</ng-container>